module.exports = __webpack_public_path__ + "static/img/loading.9da3d19.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/loading.gif
// module id = B3Bl
// module chunks = 1